module.exports = global["$"] = require("-!C:\\wamp\\www\\prestashop_1.7.3.1\\themes\\01response\\_dev\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js-exposed
// module id = 2
// module chunks = 0